import React, { useState } from "react";
import { Navbar, Container, Nav, Dropdown, Image } from "react-bootstrap";
import { MdMenu, MdLogout, MdPerson, MdAccountCircle } from "react-icons/md";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const TopHeader = ({ onMenuToggle }) => {
  const [showMenu, setShowMenu] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const handleProfileMenuOpen = () => setShowMenu(true);
  const handleMenuClose = () => setShowMenu(false);

  const handleLogout = async () => {
    handleMenuClose();
    await logout();
    navigate("/login");
  };

  const handleProfile = () => {
    handleMenuClose();
    // Navigate to profile page or open profile modal
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    const initials = (words[0]?.charAt(0) || "") + (words[1]?.charAt(0) || "");
    return initials.toUpperCase();
  };

  return (
    <Navbar bg="white" expand="md" className="shadow-sm" sticky="top">
      <Container fluid>
        {isMobile && (
          <Nav.Link onClick={onMenuToggle} className="me-2">
            <MdMenu size={24} />
          </Nav.Link>
        )}
        <Navbar.Brand className="me-auto">
          {user?.name ? `Welcome, ${user.name}` : "Dashboard"}
        </Navbar.Brand>
        <div className="d-none d-sm-block me-2" style={{ color: "#6c757d" }}>
          {user?.email}
        </div>
        <Dropdown
          align="end"
          show={showMenu}
          onToggle={setShowMenu}
          className="profile-dropdown"
        >
          <Dropdown.Toggle
            variant="light"
            id="dropdown-user"
            onClick={handleProfileMenuOpen}
            className="d-flex align-items-center justify-content-center fw-bold"
          >
            {user?.name ? (
              <>{getInitials(user.name)}</>
            ) : (
              <MdAccountCircle size={28} />
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
            <Dropdown.Item onClick={handleProfile}>
              <MdPerson className="me-2" /> Profile
            </Dropdown.Item>
            <Dropdown.Item onClick={handleLogout}>
              <MdLogout className="me-2" /> Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </Navbar>
  );
};

export default TopHeader;
